/* Measure whitespace in the original photo; only CSS positioning changes. */
(() => {
  const seen = new WeakSet();
  const measure = (image) => {
    if (!image.naturalWidth || !image.naturalHeight) return;
    try {
      const side = 192;
      const canvas = document.createElement('canvas');
      canvas.width = side;
      canvas.height = side;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      context.drawImage(image, 0, 0, side, side);
      const pixels = context.getImageData(0, 0, side, side).data;
      const background = (i) => pixels[i + 3] < 24 || Math.min(pixels[i], pixels[i + 1], pixels[i + 2]) > 246;
      // Lifestyle photos and dark product graphics retain their original framing.
      let clear = 0;
      let sampled = 0;
      for (let y = 0; y < side; y++) {
        for (let x = 0; x < side; x++) {
          if ((x < 8 || x >= side - 8) && (y < 8 || y >= side - 8)) {
            sampled++;
            if (background((y * side + x) * 4)) clear++;
          }
        }
      }
      if (clear / sampled < 0.98) return;
      let left = side, top = side, right = -1, bottom = -1;
      for (let y = 0; y < side; y++) {
        for (let x = 0; x < side; x++) {
          const i = (y * side + x) * 4;
          if (pixels[i + 3] < 40 || Math.min(pixels[i], pixels[i + 1], pixels[i + 2]) > 238) continue;
          left = Math.min(left, x); right = Math.max(right, x);
          top = Math.min(top, y); bottom = Math.max(bottom, y);
        }
      }
      if (right < left || bottom < top) return;
      const max = Math.max(image.naturalWidth, image.naturalHeight);
      const width = image.naturalWidth / max, height = image.naturalHeight / max;
      const occupied = Math.max((right - left + 1) / side * width, (bottom - top + 1) / side * height);
      if (occupied < 0.2) return;
      const scale = Math.min(4, 0.82 / occupied);
      const x = (0.5 - (left + right + 1) / (2 * side)) * width * scale * 100;
      const y = (0.5 - (top + bottom + 1) / (2 * side)) * height * scale * 100;
      image.style.setProperty('--nlx-photo-scale', scale.toFixed(4));
      image.style.setProperty('--nlx-photo-x', `${x.toFixed(3)}%`);
      image.style.setProperty('--nlx-photo-y', `${y.toFixed(3)}%`);
      image.dataset.packshotAligned = 'true';
    } catch (_) {
      // The standard contain layout remains usable if CORS or canvas is unavailable.
    }
  };
  const attach = () => {
    document.querySelectorAll('img.nlx-packshot, img[data-nlx-packshot]').forEach((image) => {
      if (seen.has(image)) return;
      seen.add(image);
      image.addEventListener('load', () => measure(image));
      if (image.complete) measure(image);
    });
  };
  attach();
  document.addEventListener('shopify:section:load', attach);
  // Collection filtering replaces cards without a full page reload.
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(attach).observe(main, { childList: true, subtree: true });
})();
